


<div class="container">
    <div class="row">

        <div class="col-md-6">

            <div class="photoframe" (click)="toggleZoom()" style="background-image: url('https://res.cloudinary.com/orderfield/image/upload/c_scale,w_1000/v1570106126/harryshorse/products/26200511_zwart-1.jpg');">
                &#160;
            </div>

            <div class="zoomed-image-modal" [ngClass]="{ 'zoomed-image-modal-active': zoomIsActive }">
                <button (click)="toggleZoom()" class="btn-close"><i class="fa fa-window-close"></i></button>
                <div class="image-wrapper">
                    <div id="zoomed-image" [ngStyle]="{'background-image': getZoomUrl()}"></div>
                </div>
            </div>

            <!--
            <div class="thumbs">
                <div class="thumb" style="background-image: url('https://res.cloudinary.com/orderfield/image/upload/w_100/v1570106126/harryshorse/products/26200511_zwart-1.jpg"></div>
            </div>
            -->

        </div>
        <div class="col-md-6">

            <h1>Product Name</h1>

            <h3 class="code-and-more">
                <span class="code"> 923423423  </span>
                <span class="divider">|</span>
                Price: &#8364; 19,95 
                <span class="divider">|</span> 
                Order unit: 3
            </h3>

            <p class="description">
                Sportief rijjasje met afritsbare capuchon. Voorzien van een twee-weg rits en handige zakjes met rits.
            </p>

            <label>Color</label>
            <select name="color" class="form-control">
                <option value="1239283">White</option>
                <option value="1239283">Navy</option>
                <option value="1239283">Black</option>
            </select>

            <div class="product-size-row-table">
                <div class="row row-head row-bottom-bordered">
                    <div class="col-md-3">Size</div>
                    <div class="col-md-3">Price</div>
                    <div class="col-md-3">Stock</div>
                    <div class="col-md-3"></div>
                </div>
                <app-product-size-row *ngFor="let size of sizes" [size]="size"></app-product-size-row>
            </div>

         
        </div>
    </div>


</div>


